export const GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_START = 'GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_START';

export const GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_SUCCESS = 'GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_SUCCESS';

export const GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_FAILED = 'GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_FAILED';

